<template>
  <nav class="justify-content-center" aria-label="Page navigation example">
    <ul class="pagination">
      <li class="page-item mr-2 first-page-btn">
        <a class="page-link" href="#/" @click="handleOnChange(1)"><i class="fa fa-step-backward"></i></a>
      </li>

      <div class="page-btn-container">
        <li class="page-item" v-bind:class="{ active: currentPage == n }" v-for="n in pageNumbers" v-bind:key="n">
          <a class="page-link" href="#/" @click="handleOnChange(n)">{{ n }}</a>
        </li>
      </div>

      <li class="page-item ml-2 last-page-btn">
        <a class="page-link" href="#/" @click="handleOnChange(pageNumbers)"><i class="fa fa-step-forward"></i> </a>
      </li>
    </ul>
  </nav>
</template>

<style lang="scss" scoped>
.page-btn-container {
  display: flex;
  background-color: var(--white);
  padding: 8px 28px 8px;
  border-radius: 8px;

  .page-item {
    .page-link {
      border: none;
      color: var(--main-font-color) !important;
    }
    &.active {
      .page-link {
        border-radius: 5px;
        background-color: #f0f3f4;
        font-weight: 600;
        color: var(--main-font-color) !important;
      }
    }
  }
}

.first-page-btn,
.last-page-btn {
  padding: 8px 8px;
  background-color: #f0f3f4;
  border-radius: 8px;
  border: 1px solid #e1e5e8;
  .page-link {
    background-color: #f0f3f4;
    border: none;
  }
}
</style>

<script>
export default {
  name: "pagination",
  props: {
    rows: {
      type: Number,
      required: true,
    },

    perPage: {
      type: Number,
      required: true,
    },
    ariacontrols: {
      type: String,
      required: true,
      default: "",
    },
    align: {
      type: String,
      required: true,
      default: "left",
    },
    currentPage: {
      default: 1,
    },
  },

  computed: {
    classes() {
      return "sf-pagination " + this.$props.class;
    },

    pageNumbers() {
      // console.log(this.$props.rows)
      // console.log(this.$props.perPage)
      const numberLimit = Math.ceil(this.$props.rows / this.$props.perPage);
      return numberLimit == 0 ? 1 : numberLimit;
    },
  },

  setup() {},

  methods: {
    handleOnChange(pageNumber) {
      this.currentPage = pageNumber;
      this.$emit("change", pageNumber);
    },
  },

  components: {},
};
</script>
